'use client'

import { createContext, useContext } from 'react'

import { DEFAULT_DLP_THEME, resolveDlpTheme, type CmsDlpTheme } from '@/lib/dlp-theme'

const DlpThemeContext = createContext<CmsDlpTheme>(DEFAULT_DLP_THEME)

interface DlpThemeProviderProps {
  children: React.ReactNode
  theme?: string | null
}

export function DlpThemeProvider({ children, theme }: DlpThemeProviderProps) {
  const value = resolveDlpTheme(theme)
  return <DlpThemeContext.Provider value={value}>{children}</DlpThemeContext.Provider>
}

export function useDlpTheme(): CmsDlpTheme {
  return useContext(DlpThemeContext)
}
